"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistServiceEventType = void 0;
var WishlistServiceEventType;
(function (WishlistServiceEventType) {
    WishlistServiceEventType["WISHLIST_SERVICE_READY"] = "WishlistServiceReady";
    WishlistServiceEventType["WISHLIST_SYNCED"] = "WishlistSynced";
})(WishlistServiceEventType = exports.WishlistServiceEventType || (exports.WishlistServiceEventType = {}));
